<template>
  <div class="audio-wrapper" v-show="audioSrc">
    <div class="audio-box">
      <audio id="audio" ref="audio">
        <source :src="audioSrc" />
      </audio>
      <div class="audio-left">
        <span class="audio-length-current" id="audioCurTime">{{tramsTime(currentTime)}}</span>
        <span
          class="audio-icon"
          :class="{'el-icon-video-pause': !isPaued, 'el-icon-video-play': isPaued}"
          id="audioPlayer"
          @click="palyerAudio"
        ></span>
      </div>
      <div class="audio-middle">
        <div class="progress-bar-bg" id="progressBarBg">
          <span id="progressDot" :style="{'left':progressWidth}"></span>
          <div class="progress-bar" id="progressBar" :style="{'width':progressWidth}"></div>
        </div>
      </div>
      <div class="audio-right">
        <span class="audio-length-total">{{tramsTime(duration)}}</span>
      </div>
    </div>
    <p class="audio-tips">试听不满意请调整参数后重新转换</p>
  </div>
</template>
<script>
export default {
  props: ['audioSrc'],
  data () {
    return {
      isPaued: true,
      progressWidth: 0,
      currentTime: 0,
      duration: 0
    }
  },
  mounted () {
    console.log('mounted')
    this.init()
  },
  updated () {
    console.log('updated')
  },
  methods: {
    init () {
      this.$refs.audio.addEventListener('timeupdate', this.updateProgress, false)
      this.initTime()
    },
    initTime () {
      // 当浏览器能够开始播放指定的音频/视频时，触发canplay事件
      this.$refs.audio.addEventListener('canplay', this.canAudioPlay, false)
    },
    canAudioPlay () {
      console.log('canplay')
      this.progressWidth = 0
      this.currentTime = this.$refs.audio ? this.$refs.audio.currentTime : 0
      this.duration = this.$refs.audio ? this.$refs.audio.duration : 0
    },
    palyerAudio () {
      if (audio.paused) {
        this.$refs.audio.play()
        this.isPaued = false
      } else {
        this.$refs.audio.pause()
        this.isPaued = true
      }
    },
    updateProgress () {
      const val = this.$refs.audio.currentTime / this.$refs.audio.duration
      if (val == 1) {
        this.isPaued = true
      }
      this.progressWidth = val * 100 + '%'
      this.currentTime = this.$refs.audio.currentTime
    },
    tramsTime (value) {
      var time = ''
      var h = parseInt(value / 3600)
      value %= 3600
      var m = parseInt(value / 60);
      var s = parseInt(value % 60);
      if (h > 0) {
        time = this.formatTime(h + ":" + m + ":" + s);
      } else {
        time = this.formatTime(m + ":" + s);
      }
      return time
    },
    formatTime (value) {
      var time = "";
      var s = value.split(':');
      var i = 0;
      for (; i < s.length - 1; i++) {
        time += s[i].length == 1 ? ("0" + s[i]) : s[i];
        time += ":";
      }
      time += s[i].length == 1 ? ("0" + s[i]) : s[i];

      return time;
    },
    resetData () {
      this.isPaued = true
      this.progressWidth = 0
      this.currentTime = 0
      this.duration = 0
    }
  },
  beforeDestroy () {
    console.log('beforeDestroy')
    this.$refs.audio.removeEventListener('timeupdate', this.updateProgress)
    this.$refs.audio.removeEventListener('canplay', this.canAudioPlay)
  },
  watch: {
    audioSrc (newVal, oldVal) {
      if (newVal !== oldVal) {
        // 更新aduio需要重新载入，调用audio的load的方法
        this.resetData()
        this.$refs.audio.load()
      }
    }
  }
}
</script>
<style lang="less">
</style>


// WEBPACK FOOTER //
// packages/text-to-audio/src/audio.vue